import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";
import { AppState } from "app/App Store/state";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { Course } from "app/shared/models/course.model";
import { DynamicDetailComponent } from "app/pages/full-pages/admin/dynamic-detail/dynamic-detail.component";


@Component({
  selector: 'app-my-sessions',
  templateUrl: './my-sessions.component.html',
  styleUrls: ['./my-sessions.component.scss'],
  
})
export class MySessionsComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild("name") inputName;

  page = {
    pageNumber: 1,
    offset: 0,
    pageSize: 100,
    totalPages: 0,
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = "";
  sections: any = [];
  isFilter: boolean = false;
  // column header
  public columns = [
    { name: "Class Name", prop: "title" },
    { name: "Actions", prop: "actions" },
  ];

  imageUrl = environment.apiUrls.imageUrl;
  main_menu_id: any;
  activeTab: any;
  class_id: any;

  guideline_data: any;
  pageNumberSubscription: Subscription;
  select_Course;
  constructor(
    public apiService: ApiService,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private activerouter: ActivatedRoute,
    private route: Router,
    private store: Store<AppState>
  ) {
     this.activerouter.paramMap.subscribe((params) => {
      this.select_Course  = params.get("id");
    });
    this.activerouter.queryParamMap.subscribe((params) => {
      let page = +params.get("page");
      this.setPage(page);
    });
    this.pageNumberSubscription = this.store
      .select((state) => state.page.pageNumber)
      .subscribe((pageNumber) => {
        this.page.pageNumber = pageNumber;
        if (pageNumber !== undefined) {
          this.page.pageNumber = pageNumber - 1;
        }
        if (pageNumber === 0) this.page.pageNumber = 0;
      });
  }

  ngOnInit() {
    if(this.select_Course){
      console.log(this.select_Course)
      this.getclassTemplatesByCourseId(this.select_Course);
    }
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getclassTemplatesByCourseId(id) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService
      .getclassTemplatesByCourseId(1, 100, id)
      .subscribe((res: any) => {
        console.log('res',res);
        this.spinner.hide();
        const { data } = res;
        this.rows = data?.items;
        this.page.totalPages = res?.data?.totalCount;
      });
  }

  pageChangeData(page: any) {
    this.route.navigate([], {
      relativeTo: this.activerouter,
      queryParams: { page: page.offset + 1 },
      queryParamsHandling: "merge", // keep existing query params
    });
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.getAllClassTemplate().subscribe((res: any) => {
      this.spinner.hide();
      this.setPage(page.offset + 1);
      this.rows = res.data.items;
      this.page.totalPages = res.data.totalCount;
    });
  }


  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  viewTopics(topics) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.topics = topics;
  }
}
